

try {
    if (typeof sfraDatalayer === 'undefined') {
        window.sfraDatalayer = {
            data: {},
            event: [],
        };
    }

    const sfraTrackingData = {};
    document.addEventListener('DOMContentLoaded', function () {
        window.assignTracking = function (nodePropertyName, trackingObject, node) {
            const tmp = JSON.parse(node.dataset[nodePropertyName]);
            if (tmp && tmp.constructor === Array) {
                tmp.forEach((m) => {
                    Object.assign(trackingObject, m);
                });
            }
        };
        const viewNodes = document.querySelectorAll('[data-tracking-view]');
        // eslint-disable-next-line no-undef
        viewNodes.forEach(assignTracking.bind(this, 'trackingView', sfraTrackingData));

        window.sfraDatalayer.data = sfraTrackingData;

        // eslint-disable-next-line no-unused-vars
        window.$('body').on('product:beforeAddToCart', (event, data) => {
            sfraDatalayer.event.push('beforeAddToCart event');
        });

        // eslint-disable-next-line no-unused-vars
        window.$('body').on('product:afterAddToCart', (event, data) => {
            sfraDatalayer.event.push('afterAddToCart event');
        });

        // eslint-disable-next-line no-unused-vars
        window.$('body').on('search:sort', (event, data) => {
            sfraDatalayer.event.push('grid sort');
        });


        window.$('body').on('datalayerEvent:link', (event, data) => {
            let eventObj = data.datalayerEvent;
            // pass only the object if length is 1, else pass the complete object to dataLayer
            if (eventObj && eventObj.length === 1) {
                // eslint-disable-next-line prefer-destructuring
                eventObj = eventObj[0];
            }
            sfraDatalayer.event.push(eventObj);
        });
    });
} catch (e) {
    // temporary work around to force a server side log entry if an exception happens
    const head = document.getElementsByTagName('head').item(0);
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', `\${URLUtils.https("Error-Force").abs()}?exception=${e.toString()}`);
    head.appendChild(script);
}

